export default __webpack_public_path__ + "static/media/sofa-2-seat-2-back.f15f3cbd.png";